module.exports = __webpack_public_path__ + "static/media/shield-check-solid.8d5713ef.svg";